import { graphql } from "gql.tada";
import { RichEntryFragment } from "./fragments/RichEntryFragment";

/**
 * Slim query for the newsletter sign-up info rich entry (phase-4 A2 — the
 * rich consent paragraph stays in the CMS). Targets the footer singleton
 * (entry id 72Rc2pWeHfODtItpnHsZf, the "theoneandonlyfooter" singleton row);
 * the rest of the footer chrome is served from local config.
 */
export const GetNewsletterSignUpInfo = graphql(
  /* GraphQL */ `
    query GetNewsletterSignUpInfo($locale: String, $preview: Boolean) {
      footerCollection(
        locale: $locale
        preview: $preview
        where: { singletonEnforcedString: "theoneandonlyfooter" }
        limit: 1
      ) {
        items {
          __typename
          newsletterSignUpInfoRichText {
            ...RichEntryFragment
          }
        }
      }
    }
  `,
  [RichEntryFragment]
);
